import axios from 'axios'
import { useCallback } from 'react'

const useCourtClient = () => {
  const getById = useCallback((Id) => axios.get(`/Vara/findById?id=${Id}`).then((res) => res?.data), [])
  const getByProcessNumber = useCallback((processNumber) => axios.get(`/Vara/GetByProcessNumber?processNumber=${processNumber}`).then((res) => res?.data), [])

  return useCallback(() => ({
    getById,
    getByProcessNumber,
  }), [
    getById,
    getByProcessNumber,
  ])
}

export default useCourtClient
